export async function protect<U>(fn: () => Promise<U> | U, scope?: unknown): Promise<U | undefined> {
    try {
        // Здесь на самом деле важно уметь обрабатывать и асинхронные и синхронные функции
        return await fn.apply(scope);
    } catch (_error) {
        return undefined;
    }
}
